import { useEffect, useContext } from 'react'
import { AnalyticsContext, useConfig } from 'providers/AnalyticsProvider'
import { ANALYTICS } from 'constants/analytics'
import { useBot } from 'hooks/useBot'
import Cookies from 'js-cookie'
import packageJson from '../../../package.json'

let rumLoadPromise = null

/** RUM is loaded only in the browser so SSR/build workers never execute the SDK entry (defineGlobal). */
function loadDatadogRum() {
  if (typeof window === 'undefined') {
    return Promise.resolve(null)
  }
  if (!rumLoadPromise) {
    rumLoadPromise = import('@datadog/browser-rum').then((m) => m.datadogRum)
  }
  return rumLoadPromise
}

const initDatadog = ({ config, datadogRum }) => {
  const applicationId = config.NEXT_PUBLIC_DATADOG_APPLICATION_ID
  const clientToken = config.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
  const env = config.NEXT_PUBLIC_DATADOG_ENV
  const service = config.NEXT_PUBLIC_DATADOG_SERVICE
  const version = packageJson.version || '0.0.0'

  if (!applicationId || !clientToken || !env) return
  if (datadogRum.getInitConfiguration()) return
  datadogRum.init({
    applicationId,
    clientToken,
    site: ANALYTICS.DATADOG_SITE,
    service,
    env,
    version,
    sampleRate: 100,
    premiumSampleRate: 50,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  })
}

const useDatadog = () => {
  const { config } = useConfig()
  const { isBot } = useBot()
  const {
    state: {
      browser_id: achieve_browser_id,
      profile_id: achieve_profile_id,
      auth0_user_id,
      auth0_email,
    } = {},
  } = useContext(AnalyticsContext)
  const session_id = Cookies.get('eh_session_id')

  useEffect(() => {
    if (isBot) return
    let cancelled = false
    loadDatadogRum().then((datadogRum) => {
      if (cancelled || !datadogRum) return
      initDatadog({ config, datadogRum })
      datadogRum.startSessionReplayRecording()
      const userId = auth0_user_id || achieve_browser_id
      if (userId) {
        datadogRum.setUser({
          id: userId,
          achieve_browser_id,
          session_id,
          achieve_profile_id,
          auth0_user_id,
          auth0_email,
        })
      } else {
        datadogRum.clearUser()
      }
    })
    return () => {
      cancelled = true
      loadDatadogRum().then((datadogRum) => {
        if (!datadogRum) return
        datadogRum.stopSessionReplayRecording()
        datadogRum.clearUser()
      })
    }
  }, [
    config,
    isBot,
    achieve_browser_id,
    session_id,
    achieve_profile_id,
    auth0_user_id,
    auth0_email,
  ])
}

export { useDatadog }
